// The route registry: every HTTP operation of the slice.

import { accessRoutes } from "./access";
import { agencyRoutes } from "./agency";
import { agentIssueRoutes } from "./agent-issues";
import { agentKpiRoutes } from "./agent-kpis";
import { agentPolicyRoutes } from "./agent-policy";
import { agentProfileSpecRoutes } from "./agent-profile-spec";
import { agentReachRoutes } from "./agent-reach";
import { agentRecordRoutes } from "./agent-record";
import { agentRequestRoutes } from "./agent-requests";
import { agentRoomRoutes } from "./agent-rooms";
import { agentSpecRoutes } from "./agent-spec";
import { agentRoutes } from "./agents";
import { assessRoutes } from "./assess";
import { baseRulesRoutes } from "./base-rules";
import { billingRoutes } from "./billing";
import { businessRoutes } from "./business";
import { cadenceRoutes } from "./cadence";
import { calendarRoutes } from "./calendar";
import { canvasRoutes } from "./canvas";
import { canvasTimelineRoutes } from "./canvas-timeline";
import { canvasVoiceRoutes } from "./canvas-voice";
import { chatRoutes } from "./chat";
import { chatFileRoutes } from "./chat-files";
import { chatPresenceRoutes } from "./chat-presence";
import { chatSwitchRoutes } from "./chat-switch";
import { chatSwitchBRoutes } from "./chat-switch-b";
import { clientOnboardingRoutes } from "./client-onboarding";
import { commitmentRoutes } from "./commitments";
import { companyExportRoutes } from "./company-export";
import { connectionRoutes } from "./connections";
import { contactRoutes } from "./contacts";
import { controlRoutes } from "./control";
import { cosRoutes } from "./cos";
import { cosModeRoutes } from "./cos-modes";
import { crewConnectionRoutes } from "./crew-connections";
import { crewRoutes } from "./crews";
import { crmRoutes } from "./crm";
import { deBriefRoutes } from "./de-briefs";
import { deConfigRoutes } from "./de-config";
import { deInitiateRoutes } from "./de-initiate";
import { decideRoutes } from "./decide";
import { eventRoutes } from "./events";
import { fileRoutes } from "./files";
import { financeRoutes } from "./finance";
import { financeViewRoutes } from "./finance-views";
import { flowRoutes } from "./flows";
import { helperOfferRoutes } from "./helper-offers";
import { importRunRoutes } from "./import-runs";
import { inboundWebhookRoutes } from "./inbound-webhooks";
import { incidentRoutes } from "./incidents";
import { insightRoutes } from "./insights";
import { intakeRoutes } from "./intake";
import { itemTemplateRoutes } from "./item-templates";
import { knowledgeRoutes } from "./knowledge";
import { ledgerRoutes } from "./ledger";
import { liveRoutes } from "./live";
import { loopBreakerRoutes } from "./loop-breaker";
import { mailRoutes } from "./mail";
import { meRoutes } from "./me";
import { measurementRoutes } from "./measurement";
import { memoryRoutes } from "./memory";
import { memoryGovernanceRoutes } from "./memory-governance";
import { memoryPeopleRoutes } from "./memory-people";
import { memoryQualityRoutes } from "./memory-quality";
import { memoryRolesRoutes } from "./memory-roles";
import { modelPolicyRoutes } from "./model-policy";
import { monitoringRoutes } from "./monitoring";
import { oooRoutes } from "./ooo";
import { operatorRoutes } from "./operator";
import { operatorConsoleRoutes } from "./operator-console";
import { operatorWorkspaceRoutes } from "./operator-workspace";
import { opportunityRoutes } from "./opportunities";
import { opsAccountRoutes } from "./ops-account";
import { orgRoutes } from "./org";
import { outboxRoutes } from "./outbox";
import { pageRoutes } from "./pages";
import { portfolioRoutes } from "./portfolio";
import { postResultsRoutes } from "./post-results";
import { processRoutes } from "./process";
import { provisioningRoutes } from "./provisioning";
import { pushRoutes } from "./push";
import { reportingRoutes } from "./reporting";
import { reportRoutes } from "./reports";
import { requestRecoveryRoutes } from "./request-recovery";
import { revertRoutes } from "./reverts";
import { roleTemplateRoutes } from "./role-templates";
import { type HttpMethod, honoPath, type RouteDef } from "./route";
import { effortDefaultsRoutes, runEffortRoutes } from "./run-effort";
import { satelliteRoutes } from "./satellites";
import { screensRoutes } from "./screens";
import { seatBoardsRoutes } from "./seat-boards";
import { seatServesRoutes } from "./seat-serves";
import { serviceEndpointRoutes } from "./service-endpoints";
import { skillPackRoutes, skillRoutes } from "./skill-packs";
import { skillProposalRoutes } from "./skill-proposals";
import { skillsmithRoutes } from "./skillsmith";
import { structureRoutes } from "./structure";
import { externalRoutes, systemRoutes } from "./system";
import { taskDetailRoutes } from "./task-detail";
import { undoRoutes } from "./undo";
import { voiceRoutes } from "./voice";
import { walletRoutes } from "./wallet";
import { workRoutes } from "./work";
import { workBundleRoutes } from "./work-bundle";
import { workforceRoutes } from "./workforce";

export * from "./access";
export * from "./agency";
export * from "./agent-issues";
export * from "./agent-kpis";
export * from "./agent-policy";
export * from "./agent-profile-spec";
export * from "./agent-reach";
export * from "./agent-record";
export * from "./agent-requests";
export * from "./agent-rooms";
export * from "./agent-spec";
export * from "./agent-spec-v2";
export * from "./agents";
export * from "./assess";
export * from "./base-rules";
export * from "./billing";
export * from "./business";
export * from "./cadence";
export * from "./calendar";
export * from "./canvas";
export * from "./canvas-timeline";
export * from "./canvas-voice";
export * from "./chat";
export * from "./chat-files";
export * from "./chat-presence";
export * from "./chat-switch";
export * from "./chat-switch-b";
// ONBOARDING-P1
export * from "./client-onboarding";
export * from "./commitments";
export * from "./common";
export * from "./company-export";
export * from "./connections";
export * from "./contacts";
export * from "./control";
export * from "./cos";
export * from "./cos-modes";
export * from "./crew-connections";
export * from "./crews";
export * from "./crm";
export * from "./de-briefs";
export * from "./de-config";
export * from "./de-initiate";
export * from "./decide";
export * from "./direction";
export * from "./events";
export * from "./files";
export * from "./finance";
export * from "./finance-views";
export * from "./flows";
export * from "./helper-offers";
export * from "./import-runs";
export * from "./inbound-webhooks";
// CORE-FREEZE
export * from "./incidents";
export * from "./insights";
export * from "./intake";
export * from "./item-templates";
export * from "./knowledge";
export * from "./ledger";
export * from "./live";
export * from "./loop-breaker";
export * from "./mail";
export * from "./me";
export * from "./measurement";
export * from "./memory";
export * from "./memory-governance";
export * from "./memory-people";
export * from "./memory-quality";
// RECALL-ROLES-ONBOARDING
export * from "./memory-roles";
export * from "./model-policy";
// MONITORING-P1
export * from "./monitoring";
export * from "./obligations";
export * from "./ooo";
export * from "./operator";
export * from "./operator-console";
export * from "./operator-workspace";
export * from "./opportunities";
export * from "./ops-account";
export * from "./org";
export * from "./outbox";
export * from "./pages";
export * from "./portfolio";
export * from "./post-results";
export * from "./process";
export * from "./provisioning";
export * from "./push";
export * from "./reporting";
export * from "./reports";
export * from "./request-recovery";
// CORE-REVERT
export * from "./reverts";
export * from "./role-templates";
export * from "./route";
export * from "./run-effort";
export * from "./satellites";
export * from "./screens";
export * from "./seat-boards";
export * from "./seat-serves";
export * from "./service-endpoints";
export * from "./skill-packs";
// SKILL-PROPOSALS
export * from "./skill-proposals";
// SKILLSMITH-LENS
export * from "./skillsmith";
export * from "./space-shares";
export * from "./structure";
export * from "./system";
export * from "./task-detail";
export * from "./undo";
// VOICE-CHOICES
export * from "./voice";
export * from "./wallet";
export * from "./work";
export * from "./work-bundle";
export * from "./workforce";

export const routes = {
  ...systemRoutes,
  ...operatorRoutes,
  ...agencyRoutes,
  ...orgRoutes,
  // MEETINGS
  ...cadenceRoutes,
  // CALENDAR-C1
  ...calendarRoutes,
  // M8-ASSESS
  ...assessRoutes,
  ...measurementRoutes,
  ...ledgerRoutes,
  // OOO-DELEGATE
  ...oooRoutes,
  // lane B: REQUEST-IDENTITY / REQUEST-RECOVERY
  ...requestRecoveryRoutes,
  ...reportRoutes,
  ...eventRoutes,
  ...liveRoutes,
  // CANVAS-CORE + LIVE-EVENTS
  ...canvasRoutes,
  // CANVAS-VOICE
  ...canvasVoiceRoutes,
  // VOICE-CHOICES
  ...voiceRoutes,
  // SESSION-TIMELINE
  ...canvasTimelineRoutes,
  ...chatRoutes,
  ...workRoutes,
  // WOS-BUNDLE
  ...workBundleRoutes,
  // B4-ITEM-TEMPLATES
  ...itemTemplateRoutes,
  ...commitmentRoutes,
  // BIZ-PLAYBOOKS / BIZ-CLIENT-HEALTH
  ...businessRoutes,
  ...agentRoutes,
  // AGENT-KPI-TOOL
  ...agentKpiRoutes,
  // AGENT-REPORTING
  ...reportingRoutes,
  // TEMPLATES-T2..T4: roles, overlays, vertical packs, deploy from a role, access, probation
  ...roleTemplateRoutes,
  ...crewRoutes,
  ...agentRoomRoutes,
  ...financeRoutes,
  ...financeViewRoutes,
  ...deConfigRoutes,
  ...memoryRoutes,
  // RECALL-RETENTION-HOLD-FORGET
  ...memoryGovernanceRoutes,
  // RECALL-PEOPLE-SURFACES
  ...memoryPeopleRoutes,
  // RECALL-ROLES-ONBOARDING
  ...memoryRolesRoutes,
  // MEMORY-QUALITY-WATCH
  ...memoryQualityRoutes,
  // MONITORING-P1: run telemetry, stop requests, alerts, guards
  ...monitoringRoutes,
  // SKILL-PROPOSALS: agents propose skills, people approve, the repo ships
  ...skillProposalRoutes,
  // SKILLSMITH-LENS: the super admin's remote control (fleet lens, reports, orders, drafts, actions)
  ...skillsmithRoutes,
  // BYO-01
  ...connectionRoutes,
  // M4-02
  ...skillPackRoutes,
  // SKILL-OVERRIDES
  ...skillRoutes,
  ...pageRoutes,
  // M4-04
  ...crewConnectionRoutes,
  // MODEL-POLICY
  ...modelPolicyRoutes,
  // RUN-EFFORT
  ...runEffortRoutes,
  ...effortDefaultsRoutes,
  // DOCS-KB
  ...knowledgeRoutes,
  // TASK-FILES
  ...fileRoutes,
  // CHAT-FILES
  ...chatFileRoutes,
  // CHAT-SWITCH-A
  ...chatSwitchRoutes,
  // CHAT-SWITCH-B
  ...chatSwitchBRoutes,
  // CHAT-PRESENCE
  ...chatPresenceRoutes,
  // DE-INITIATE
  ...deInitiateRoutes,
  // SKILLSMITH-HUB: an agent files an Agent issues entry (write-only)
  ...agentIssueRoutes,
  // B5-DECIDE
  ...decideRoutes,
  // LOOP-BREAKER: turns, loop incidents, thresholds
  ...loopBreakerRoutes,
  // SKILLSMITH-OPPORTUNITIES: the helper sales pipeline and paid helper quotes
  ...opportunityRoutes,
  ...helperOfferRoutes,
  // ADMIN-INSIGHTS: the owners-and-admins Ask panel and pinned answers
  ...insightRoutes,
  // DE-BRIEFS
  ...deBriefRoutes,
  // IMPORT (HARDEN)
  ...importRunRoutes,
  // HARDEN-pwa
  ...pushRoutes,
  // SCREENS-S1
  ...screensRoutes,
  // FOUNDER-OS
  ...portfolioRoutes,
  // Parity P6a
  ...agentPolicyRoutes,
  // Parity P1 (wave 0)
  ...undoRoutes,
  // CORE-FREEZE
  ...incidentRoutes,
  // CORE-REVERT
  ...revertRoutes,
  // Parity P1 (wave 1)
  ...meRoutes,
  ...taskDetailRoutes,
  // BOARD-RESULTS
  ...postResultsRoutes,
  // CONNECTIONS
  ...serviceEndpointRoutes,
  // SATELLITE-REGISTRY
  ...satelliteRoutes,
  // AGENT-SPEC
  ...agentSpecRoutes,
  // AGENT-SPEC-EXPORT
  ...agentProfileSpecRoutes,
  // OPS-AUTH
  ...opsAccountRoutes,
  // SUPER-ADMIN: the platform operator workspace
  ...operatorWorkspaceRoutes,
  // ONBOARDING-P1: the client's onboarding case and its intake link (CLIENT_ONBOARDING)
  ...clientOnboardingRoutes,
  // DE-BASE-RULES (P4)
  ...baseRulesRoutes,
  // Parity P5 (process engine, wave 1)
  ...processRoutes,
  // PROVISION-IN-PRODUCT
  ...provisioningRoutes,
  // OPERATOR-CONSOLE
  ...operatorConsoleRoutes,
  // WORKFORCE
  ...workforceRoutes,
  // WEBHOOKS-IN
  ...inboundWebhookRoutes,
  // WF-CONTROL
  ...controlRoutes,
  // COS-SLICE1
  ...cosRoutes,
  // COS-MODES
  ...cosModeRoutes,
  // WALLET-P1
  ...walletRoutes,
  // BILLING-PLANS
  ...billingRoutes,
  // AGENT-RECORD
  ...agentRecordRoutes,
  // MANAGED-POLICY
  ...agentRequestRoutes,
  // REACH-S1
  ...agentReachRoutes,
  // SHARED-DES
  ...seatServesRoutes,
  // AWARENESS-MVP: the boards a seat's DE uses
  ...seatBoardsRoutes,
  // GUIDED-FLOW
  ...flowRoutes,
  // STEP1-OUTBOX
  ...outboxRoutes,
  // INC2-INTAKE
  ...intakeRoutes,
  // GMAIL-P1: the Pub/Sub push door, mailbox sync, the company's own OAuth app
  ...mailRoutes,
  // INC2-CONTACT
  ...contactRoutes,
  ...accessRoutes,
  // STRUCTURE-CHANGED
  ...structureRoutes,
  // EXPORT-CORE
  ...companyExportRoutes,
  // GHL-PROVIDER: the connector-mode CRM
  ...crmRoutes,
} as const;

export type Routes = typeof routes;
export type RouteId = keyof Routes;

export const routeList: readonly RouteDef[] = Object.values(routes);

/**
 * Hono routes (`app.routes`: `{method, path}` with `:param` paths) that have no operation in the
 * registry and are not served by an external library. Middleware entries (`ALL`) are ignored.
 */
export function undocumentedRoutes(
  registered: readonly { method: string; path: string }[],
): { method: string; path: string }[] {
  const known = new Set(routeList.map((r) => `${r.method.toUpperCase()} ${honoPath(r.path)}`));
  const isExternal = (method: string, path: string) =>
    externalRoutes.some(
      (x) =>
        (x.methods as readonly string[]).includes(method) &&
        (x.path.endsWith("/*")
          ? path.startsWith(x.path.slice(0, -1)) || path === x.path
          : path === x.path),
    );
  return registered.filter(({ method, path }) => {
    const m = method.toUpperCase();
    if (m === "ALL" || m === "OPTIONS" || m === "HEAD") return false;
    return !known.has(`${m} ${path}`) && !isExternal(m, path);
  });
}

/** Registry operations whose `{method, path}` is not registered in the app (not yet built). */
export function unimplementedRoutes(
  registered: readonly { method: string; path: string }[],
): RouteDef[] {
  const have = new Set(registered.map((r) => `${r.method.toUpperCase()} ${r.path}`));
  return routeList.filter(
    (r) => !have.has(`${(r.method as HttpMethod).toUpperCase()} ${honoPath(r.path)}`),
  );
}
